import { useThemeProps } from "@mui/material";
import { useCallback } from "react";
import { toolbarButtonName } from "../ToolbarButton/classes.js";
import { useToolbarButtonGroup } from "../ToolbarButtonGroup/context/hooks/useToolbarButtonGroup.js";
import { useToolbar } from "./useToolbar.js";
function useToolbarButton(inProps) {
  const props = useThemeProps({
    name: toolbarButtonName,
    props: inProps
  });
  const { icon, onClick, selectedIcon, value } = props;
  const { activeView, setActiveView, setMetaTarget } = useToolbar();
  const { showLabels } = useToolbarButtonGroup();
  const selected = value === activeView;
  const renderedIcon = selected ? selectedIcon : icon;
  const handleClick = useCallback(
    (event) => {
      onClick?.(event);
      if (value !== void 0) {
        const target = event.currentTarget;
        setMetaTarget((prev) => prev === target ? void 0 : target);
        setActiveView((prev) => prev === value ? null : value);
      }
    },
    [onClick, setActiveView, setMetaTarget, value]
  );
  return {
    icon: renderedIcon,
    onClick: handleClick,
    selected,
    showLabel: showLabels
  };
}
export {
  useToolbarButton
};
//# sourceMappingURL=useToolbarButton.js.map
